module.exports = __webpack_public_path__ + "static/media/smartphoneUportFlipped.66a617ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smartphoneUportFlipped.png
// module id = 762
// module chunks = 1 3